export const loginStyle = {
  width: '100%',
  maxWidth: '350px',
  minWidth: '180px',
  marginBottom: '20px',
};
export const styleFields = {
  '&': loginStyle,
  '& label.Mui-focused': {
    color: '#18318e !important',
  },
  '&:hover label': {
    color: 'rgb(78, 207, 255)',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: '#18318e',
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: '#000',
    },
    '&:hover fieldset': {
      borderColor: 'rgb(78, 207, 255)',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#18318e',
    },
  },
};

export const COLORS_CONST = {
  basic: '#18318e',
  blue: '#4ecefd',
  green: '#a6a9ae',
  black: '#090401',
  red: '#fd433a',
  systemButton: '#1976d2',
};
